import { template } from "@ember/template-compiler";
import { array, concat, fn } from '@ember/helper';
import Component from '@glimmer/component';
import { task } from 'ember-concurrency';
import perform from 'ember-concurrency/helpers/perform';
import { t } from 'ember-intl';
import type { Signature as TaskDropdownSig } from 'parog-web/components/planning-board/tasks-table/task-dropdown';
import tWithDefault from 'parog-web/helpers/t-with-default';
import transitionToForc from 'parog-web/helpers/transition-to-forc';
import type TaskPlannedJournalEvent from 'parog-web/models/task-planned-journal-event';
interface Signature {
    Args: {
        task: TaskPlannedJournalEvent;
        hideShiftOther?: boolean;
        dropdown: TaskDropdownSig['Blocks']['default'][0];
        onTaskProcessedOrShifted?: () => void;
    };
}
export default class TaskDropdownItemsComponent extends Component<Signature> {
    processTask = task(async (task1, actionTaken1)=>{
        this.args.onTaskProcessedOrShifted?.();
        await task1.processTask(actionTaken1);
    });
    shiftTask = task(async (task1, unit1)=>{
        await task1.shift(1, unit1);
        this.args.onTaskProcessedOrShifted?.();
    });
    static{
        template(`
    {{#each (array 'completed' 'not-completed' 'irrelevant') as |actionTaken|}}
      <@dropdown.Item
        @onClick={{fn (perform this.processTask) @task actionTaken}}
        @key={{actionTaken}}
      >
        {{tWithDefault (concat 'task.actions.' actionTaken) actionTaken}}
      </@dropdown.Item>
    {{/each}}

    <@dropdown.Divider />

    <@dropdown.Item
      @onClick={{fn (perform this.shiftTask) @task 'days'}}
      @key='shift-day'
    >
      {{t 'task.actions.shift-day'}}
    </@dropdown.Item>
    <@dropdown.Item
      @onClick={{fn (perform this.shiftTask) @task 'weeks'}}
      @key='shift-week'
    >
      {{t 'task.actions.shift-week'}}
    </@dropdown.Item>
    <@dropdown.Item
      @onClick={{fn (perform this.shiftTask) @task 'months'}}
      @key='shift-month'
    >
      {{t 'task.actions.shift-month'}}
    </@dropdown.Item>

    {{#unless @hideShiftOther}}
      <@dropdown.Item
        @onClick={{transitionToForc
          'task'
          'edition-form'
          patient=@task.patient
          sourceJeId=@task.id
        }}
        @key='shift-other'
      >
        {{t 'task.actions.shift-other'}}
      </@dropdown.Item>
    {{/unless}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
